module.exports = __webpack_public_path__ + "img/20180815_151844_212.0ccce08a.jpg";